import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <Section className="bg-white" data-id="element-138">
      <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-12 text-center font-serif" data-id="element-139">
        Resultados Reales
      </h2>

      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-140">
        {/* Stats Card */}
        <div className="bg-[#FFF8F0] p-8 rounded-2xl shadow-lg border border-[#C9A84C]/20" data-id="element-141">
          <div className="space-y-6" data-id="element-142">
            <div data-id="element-143">
              <p className="text-sm uppercase tracking-wider text-gray-500 mb-1" data-id="element-144">
                Antes / Día 1
              </p>
              <div className="flex items-baseline" data-id="element-145">
                <span className="text-3xl font-bold text-gray-400" data-id="element-146">
                  Cintura 92cm
                </span>
              </div>
              <p className="text-gray-500 text-sm mt-1" data-id="element-147">
                Piel ondea tacto, jeans no cierra
              </p>
            </div>

            <div className="h-px bg-gray-200" data-id="element-148"></div>

            <div data-id="element-149">
              <p className="text-sm uppercase tracking-wider text-[#0D5C63] font-bold mb-1" data-id="element-150">
                Día 21
              </p>
              <div className="flex items-baseline" data-id="element-151">
                <span className="text-4xl font-bold text-[#0D5C63]" data-id="element-152">
                  Cintura 86cm
                </span>
                <span className="ml-3 bg-green-100 text-green-700 px-2 py-1 rounded-full text-sm font-bold" data-id="element-153">
                  -6cm
                </span>
              </div>
              <p className="text-[#2D2D2D] mt-1" data-id="element-154">Firmeza tacto, ropa suelta</p>
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <div className="relative" data-id="element-155">
          <Quote className="absolute -top-6 -left-6 w-12 h-12 text-[#C9A84C] opacity-30" data-id="element-156" />
          <blockquote className="text-xl md:text-2xl font-serif italic text-[#2D2D2D] leading-relaxed relative z-10" data-id="element-157">
            "Toqué abdomen sin llorar primera vez."
          </blockquote>
          <div className="mt-6 flex items-center" data-id="element-158">
            <div className="w-10 h-10 bg-[#0D5C63] rounded-full flex items-center justify-center text-white font-bold" data-id="element-159">
              M
            </div>
            <div className="ml-3" data-id="element-160">
              <p className="font-bold text-[#0D5C63]" data-id="element-161">María</p>
              <p className="text-sm text-gray-500" data-id="element-162">Miami, USA</p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}